<template>
<!--  <el-select v-model="targetValue" clearable filterable remote reserve-keyword :placeholder="placeholder"-->
<!--    :loading="loading" :remote-method="remoteMethod" @change="targetChange" >-->
<!--    <el-option v-for="(item,index) in options" :key="index" :label="item.company_name" :value="item.oid">-->
<!--    </el-option>-->
<!--  </el-select>-->
  <el-autocomplete
    popper-class="my-autocomplete"
    v-model="targetValue"
    :fetch-suggestions="remoteMethod"
    placeholder="请输入内容"
    @select="targetChange"
    style="width: 100%">
    <template slot-scope="{ item }">
      <span class="addr">{{ item.company_name }}</span>
    </template>
  </el-autocomplete>
</template>

<script>
  import appsettings from "../utils/appsettings";
  import {
    fetch
  } from '../utils/request';
  export default {
    props: ["placeholder", "value", "url" ],
    data() {
      return {
        appsettings: appsettings,
        options: [],
        loading: false,
        targetValue: "",
      };
    },
    mounted() {
      this.targetValue = this.value;
    },
    watch: {
      value: function (newVal, oldVal) {
        if (newVal != undefined) {
          this.targetValue = newVal;
          this.$forceUpdate();
        }
      }
    },
    methods: {
      remoteMethod(query, cb) {
        let _this = this;
        if (query !== '' && typeof(query)!='undefined') {
          // _this.loading = true;
          fetch('POST', _this.url, {
            company_name: query,
            page_index:1,
            page_size:100000
          }).then(res => {
            if (res.status == 0 && res.data != null) {
              _this.options = res.data.datas;
              console.log(res.data);
              cb(_this.options)
              // if(res.data.datas.length == 0){
              //   var target = {company_name:query,oid:"isNew",company_type:'002'};
              //   this.$emit("targetChanged",target);
              // }
              // if(res.data.datas.length == 0){
              //   _this.options = [
              //     {company_name:query,oid:"isNew",company_type:'002'}
              //   ]
              // }else{
              //   if(res.data.datas.findIndex(item=>item.company_name == query) == -1){
              //     res.data.datas.unshift({company_name:query,oid:"isNew",company_type:'002'})
              //   }
              //   _this.options = res.data.datas;
              // }
              // _this.loading = false;
            }
          })
        } else {
          _this.options = [];
        }
      },

      targetChange(value) {
        console.log('value---',value)
        // let index = this.options.findIndex((v) => {
        //   return v.oid === value;
        // });
        // var target = JSON.parse(JSON.stringify(this.options[index]))
        // console.log('index---',target)
        this.$emit("targetChanged",value);
      },

    }
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/IntelligentPerception.vue